import { useEffect } from 'react';
import { useFlag } from '../featureFlags';

const useZendeskWidget = () => {
    const enabled = useFlag('zendesk_widget_enabled', false);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        const script = document.createElement('script');
        script.id = 'ze-snippet';
        script.src = 'https://static.zdassets.com/ekr/snippet.js?key=4cadafd9-3a32-4983-9671-624b6c795ef4';
        script.async = true;

        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);
};

export default useZendeskWidget;
